import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Module-level cache so every page that calls useSiteCopy() shares the same fetch.
let cachedSettings = null;
let inflight = null;

function fetchSettingsOnce() {
  if (cachedSettings) return Promise.resolve(cachedSettings);
  if (!inflight) {
    inflight = api
      .get("/settings/public")
      .then((r) => {
        cachedSettings = r.data || {};
        return cachedSettings;
      })
      .catch(() => ({}))
      .finally(() => { inflight = null; });
  }
  return inflight;
}

/**
 * useSiteCopy() returns a `t(key, fallback)` function. The fallback is the literal
 * string baked into JSX — used until the network call resolves, or if a key is
 * missing/blank in the owner's overrides.
 */
export function useSiteCopy() {
  const [copy, setCopy] = useState(() => cachedSettings?.site_copy || {});

  useEffect(() => {
    let alive = true;
    fetchSettingsOnce().then((s) => {
      if (alive && s?.site_copy) setCopy(s.site_copy);
    });
    return () => { alive = false; };
  }, []);

  return (key, fallback = "") => {
    const v = copy[key];
    return v && v.trim() ? v : fallback;
  };
}

// Allow the Settings page to invalidate the cache after a save so the next page render shows fresh copy.
export function invalidateSiteCopyCache() {
  cachedSettings = null;
}
